/**
 * Sortierung der Lead-Übersicht (Spec, Abgleich Nr. 8: „sortierbare Spalten"
 * heißt alle Spalten). Leere Werte stehen in BEIDEN Richtungen am Ende — ein
 * Lead ohne Ziel ist kein Lead mit dem kleinsten Ziel.
 */
export type LeadSpalte =
  | "fullName"
  | "prevYearRevenueEur"
  | "targetRevenueEur"
  | "actualYtdEur"
  | "marginCumPct"
  | "forecastEur"
  | "forecastGrowthPct"
  | "offen"
  | "netto";

export function sortiereLeads<T extends { fullName: string }>(
  zeilen: T[],
  wert: (z: T) => number | string | null,
  richtung: "asc" | "desc",
): T[] {
  const faktor = richtung === "asc" ? 1 : -1;
  return [...zeilen].sort((a, b) => {
    const wa = wert(a);
    const wb = wert(b);
    if (wa === null && wb === null) return a.fullName.localeCompare(b.fullName, "de");
    if (wa === null) return 1;
    if (wb === null) return -1;
    const v = typeof wa === "string" || typeof wb === "string" ? String(wa).localeCompare(String(wb), "de") : wa - wb;
    return v !== 0 ? v * faktor : a.fullName.localeCompare(b.fullName, "de");
  });
}
